import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Box, Typography } from '@mui/material';

const SERVICE_COLORS = {
    web:       '#4CAF50',
    core:      '#2196F3',
    kern4good: '#00BCD4',
    infra:     '#FF9800',
    design:    '#E91E63',
    lab:       '#9C27B0',
    other:     '#607D8B',
    untagged:  '#BDBDBD',
};

const SERVICE_LABELS = {
    web:       'Web',
    core:      'Core',
    kern4good: 'Kern4Good',
    infra:     'Infra',
    design:    'Design',
    lab:       'Lab',
    other:     'Autre',
    untagged:  'Non tagué',
};

const formatCurrency = (v) =>
    new Intl.NumberFormat('fr-BE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(v || 0);

const ServiceBreakdown = ({ services }) => {
    if (!services?.by_service || Object.keys(services.by_service).length === 0) return null;

    const data = Object.entries(services.by_service)
        .map(([key, val]) => ({
            name:  SERVICE_LABELS[key] || key,
            key,
            value: val.revenue_untaxed,
            pct:   val.share_pct,
            count: val.invoice_count,
        }))
        .sort((a, b) => b.value - a.value);

    return (
        <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                CA par service
            </Typography>
            <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
                <ResponsiveContainer width="45%" height={220}>
                    <PieChart>
                        <Pie data={data} dataKey="value" nameKey="name" innerRadius={55} outerRadius={95} paddingAngle={2}>
                            {data.map((entry) => (
                                <Cell key={entry.key} fill={SERVICE_COLORS[entry.key] || '#888'} />
                            ))}
                        </Pie>
                        <Tooltip formatter={(v) => formatCurrency(v)} />
                        <Legend iconType="square" />
                    </PieChart>
                </ResponsiveContainer>
                <Box sx={{ flex: 1, minWidth: 200 }}>
                    {data.map((d) => (
                        <Box key={d.key} display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 0.75 }}>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Box sx={{ width: 12, height: 12, borderRadius: '2px', flexShrink: 0, backgroundColor: SERVICE_COLORS[d.key] || '#888' }} />
                                <Typography variant="body2">{d.name}</Typography>
                                <Typography variant="caption" color="text.secondary">({d.count})</Typography>
                            </Box>
                            <Box textAlign="right">
                                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                    {formatCurrency(d.value)}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {d.pct}%
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default ServiceBreakdown;
